
import { useEffect, useState, cloneElement } from 'react';
import css from './AnchorBasedContentTOC.module.css';
import IconCard from '../SavedCardDetails/IconCard/IconCard';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useConfiguration } from '../../context/configurationContext';
import { showCreateListingLinkForUser } from '../../util/userHelpers';
import { NamedLink } from '../NamedLink/NamedLink';

const AnchorBasedContentTOC = (props) => {
    const { heroContent, ctaSection, serviceContent } = props;
    const [activeId, setActiveId] = useState(serviceContent[0].id);
    const [acitveHeading, setActiveHeading] = useState('')
    const [dropdown, setDropdown] = useState(false)
    const config = useConfiguration();

    const showCreateListingsLink = ctaSection.sellerPage === true;

    useEffect(() => {
        const sections = document.querySelectorAll('section[data-id]');

        const observer = new IntersectionObserver(
            entries => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        setActiveId(entry.target.getAttribute('data-id'));
                        setActiveHeading(entry.target.querySelector('h2') ? entry.target.querySelector('h2').textContent : '');
                    }
                });
            },
            { rootMargin: '-10% 0px -80% 0px' }
        );

        sections.forEach(section => observer.observe(section));

        return () => observer.disconnect();
    }, []);


    return (
        <div>
            {/* hero content */}
            <div className={css.heroContent}>
                {heroContent.heading && (
                    <h2 className={css.heroTitle}><FormattedMessage id={heroContent.heading} /></h2>
                )}
                {heroContent.description && (
                    <p className={classNames(css.description1, heroContent?.spredDescription ? css.spreadDiscription : '')}>
                        <FormattedMessage id={heroContent.description} />                    </p>
                )}
                {heroContent.description2 && (
                    <p className={classNames(css.description2, heroContent?.spredDescription ? css.spreadDiscription : '')}> <FormattedMessage id={heroContent.description2} />     </p>
                )}
                {
                    heroContent.btnLabel && (
                        <a href={heroContent.btnLink} className={css.btn}>
                            <FormattedMessage id={heroContent.btnLabel} />
                        </a>
                    )
                }
            </div>


            <div className={css.policyLayoutWrapper}>
                <div className={css.policyLayout}>
                    {/* Left TOC */}
                    <nav className={css.toc}>
                        <ul>
                            {serviceContent.map((section, index) => (
                                <li key={section.id}>
                                    <a
                                        href={`#${section.id}`}
                                        className={activeId === section.id ? css.active : ''}
                                    >
                                        {String(index + 1).padStart(2, '0')}. {section.title}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    </nav>
                    {/* mobile TOC */}
                    <nav className={css.tocMobile}>
                        <div className={css.tocMobileDropdown}>
                            <h5 className={css.activeHeading} onClick={() => setDropdown(!dropdown)}>
                                {acitveHeading}
                                <span className={classNames(css.rotateIcon, dropdown ? css.rotate : null)}>
                                    <IconCard brand='chevronDown' />
                                </span>
                            </h5>

                            <nav className={classNames(css.dropdownMenu, dropdown ? css.show : css.hide)}>
                                <ul>
                                    {serviceContent.map((section, index) => (
                                        <li key={section.id}>
                                            <a
                                                href={`#${section.id}`}
                                                className={activeId === section.id ? css.active : ''}
                                            >
                                                {String(index + 1).padStart(2, '0')}. {section.title}
                                            </a>
                                        </li>
                                    ))}
                                </ul>
                            </nav>
                        </div>

                    </nav>

                    {/* Right content */}
                    <article className={css.content}>
                        {serviceContent.map((section, index) => (
                            <section
                                key={section.id}
                                id={section.id}
                                data-id={section.id}
                                className={css.section}
                            >
                                <h2 className={css.serviceHeading}>
                                    {String(index + 1).padStart(2, '0')}. {section.title}
                                </h2>
                                <div className={css.sectionContent}>
                                    {Array.isArray(section.content)
                                        ? section.content.map((node, idx) =>
                                            cloneElement(node, { key: `${section.id}-${idx}` })
                                        )
                                        : section.content}
                                </div>
                            </section>
                        ))}
                    </article>
                </div>
            </div >


            <div className={css.ctaSectionUIContainer}>
                <div className={css.ctaSectionUI}>

                    <div className={css.contentBox} style={{ backgroundColor: ctaSection.bgColor }}>

                        {ctaSection.heading
                            &&
                            <h3><FormattedMessage id={ctaSection.heading} /></h3>
                        }
                        {ctaSection.subheading
                            &&
                            <h4><FormattedMessage id={ctaSection.subheading} /></h4>
                        }
                        {ctaSection.description
                            &&
                            <p><FormattedMessage id={ctaSection.description} /></p>
                        }
                        {/* create listing button for seller only */}
                        {showCreateListingsLink ? (
                            <NamedLink name="NewListingPage">
                                <FormattedMessage id={ctaSection.ctaLabel} />
                            </NamedLink>
                        ) : (
                            <a href={ctaSection.ctaLink}><FormattedMessage id={ctaSection.ctaLabel} /></a>
                        )}
                    </div>

                    <div className={css.imgBox}>
                        {ctaSection.img && <img src={ctaSection.img} alt={ctaSection.heading} />}
                    </div>
                </div>
            </div>
        </div >
    );
};

export default AnchorBasedContentTOC;

